import { Input } from '@mantine/core';
import { useDebounce } from '../../../../../../../hooks/useDebounce';
import { useDidUpdate } from '@mantine/hooks';
import { useState } from 'react';

export default function DebouncedInput({ initialValue, onChange, delay = 600, ...props }) {
  const [value, setValue] = useState(initialValue);

  const debouncedValue = useDebounce(value, delay);

  useDidUpdate(() => {
    if (debouncedValue === initialValue) return;

    onChange(debouncedValue);
  }, [debouncedValue]);

  return (
    <Input
      {...props}
      w="100%"
      value={value}
      onChange={e => setValue(e.target.value)}
      data-testid="debounced-input"
    />
  );
}
